

export const getErrorMessage = (error: Error | any, defaultMessage: string = 'Something went wrong') => {
  if (error.response?.data?.message) {
    return error.response.data.message;
  }
  return error instanceof Error ? error.message : defaultMessage;
};